import React from "react";

// Components
import Products from "../components/Products";
import Services from "../components/Services";
import About from "../components/About";
import Filmstrip from "../components/Filmstrip";
import TextField from "@mui/material/TextField";
import Collection from "../components/Collection";
import CookieConsentBanner from "../components/CookieConsentBanner";
export default function Homepage() {
  return (
    <div className="Homepage">
      <Collection />
      {/* <Products products="popular-products" header="Popular Items" />
      <Products products="new-products" header="New Items" />
      <Products products="" header="All Items" /> */}

      {/* <Products products="fujifilm" header="New Items" />
      <Products products="kodak" header="All Items" /> */}
      <Services />
      <About />
      <CookieConsentBanner />
    </div>
  );
}
